import useSWR from "swr";
import { getClient } from "../lib/sanity.server";

const fetcher = async (query) => await getClient().fetch(query);

export default function useSanity(query) {
  const { data, error } = useSWR(query, fetcher);

  return {
    data: data,
    isLoading: !error && !data,
    isError: error,
  };
}
